import monetize, { demonetize } from '@sdk/helpers/formatters/monetize';

export function depercentize(value = '') {
  return demonetize(value);
}

export default function percentize(value = '', options = {}) {
  return monetize(value, {
    ...options,
    prefix: options.prefix !== undefined ? options.prefix : '',
    suffix: options.suffix !== undefined ? options.suffix : '%',
  });
}
